import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import MultiSelect from '@src/common/MultiSelect';
import { useDispatch, useSelector } from 'react-redux';
import ReactSelect from '@common/ReactSelect';
import DatePicker from "react-multi-date-picker";
import { getSfaUsersByRole, updateSfaUserList } from '@src/store/slices/common';
import { COUNTRY_CODE, FEATURE_LISTING, PAGE_NUMBER, STATUS_SUCCESS } from '@src/config/constant';
import { times } from 'lodash';
import { getAgencyList } from '@src/store/slices/agency';
import { useLanguage } from "@src/context/LanguageContext";


const MoreFilterOption = (props: any) => {

    let { masterConfig } = props;
    const dispatch: any = useDispatch();
    const insuranceState = useSelector((state: any) => state.insurance);

    const [selectedMoreFilters, setSelectedMoreFilters] = useState<any>({});
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [sfaUserList, setSfaUserList] = useState([]);
    const {translations} = useLanguage();
    const leadSourceOptions = (COUNTRY_CODE === 'id') ? masterConfig['lead_source_filter'] : masterConfig['lead_source_type'];    

    useEffect(() => {
        if (Object.keys(insuranceState.insuranceListFilters).length) {
            setSelectedMoreFilters({ ...insuranceState.insuranceListFilters });
        }
    }, [insuranceState]);

    useEffect(() => {
        if (COUNTRY_CODE === 'id') {
            getAgencyUsers()
        }
        //eslint-disable-next-line
    }, [])

    const handleChangeDateType = (selectedOption: any, key: string) => {

        let updatedMoreFilters: any = selectedMoreFilters;

        if (key === "from_date") {
            //here date range valye set into two different key        
            if (selectedOption.length === 2) {
                updatedMoreFilters["from_date"] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
                updatedMoreFilters["to_date"] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
            } else {
                updatedMoreFilters["from_date"] = selectedOption[0]?.format("YYYY-MM-DD");
                updatedMoreFilters["to_date"] = null; // Reset end date
            }
        }
        else if (key === "from_due_date") {
            //here date range valye set into two different key        
            if (selectedOption.length === 2) {
                updatedMoreFilters["from_due_date"] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
                updatedMoreFilters["to_due_date"] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
            } else {
                updatedMoreFilters["from_due_date"] = selectedOption[0]?.format("YYYY-MM-DD");
                updatedMoreFilters["to_due_date"] = null; // Reset end date
            }
        }
        else if (["created_by_ids"].includes(key)) {
            updatedMoreFilters[key] = selectedOption.map((v: any) => v.value);
        }
        else if (["lead_source", "username", "lead_source_type", 'vehicle_type'].includes(key)) {
            updatedMoreFilters[key] = selectedOption.map((v: any) =>  ((key ==='lead_source_type' && COUNTRY_CODE === 'id' )? v.lead_type :v.value ));
        }
        else if (key === "policy_effectivity_date") {
            //here date range valye set into two different key    
            if (selectedOption.length === 2) {
                updatedMoreFilters["policy_effectivity_date_from"] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
                updatedMoreFilters["policy_effectivity_date_to"] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
            } else {
                updatedMoreFilters["policy_effectivity_date_from"] = selectedOption[0]?.format("YYYY-MM-DD");
                updatedMoreFilters["policy_effectivity_date_to"] = null; // Reset end date
            }
        }
        else if (key === "policy_expiry_date") {
            //here date range valye set into two different key            
            if (selectedOption.length === 2) {
                updatedMoreFilters["policy_expiry_date_from"] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
                updatedMoreFilters["policy_expiry_date_to"] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
            } else {
                updatedMoreFilters["policy_expiry_date_from"] = selectedOption[0]?.format("YYYY-MM-DD");
                updatedMoreFilters["policy_expiry_date_to"] = null; // Reset end date
            }

        }
        else {
            updatedMoreFilters[key] = selectedOption['value'];

        }

        setSelectedMoreFilters({ ...updatedMoreFilters });

    };

    useEffect(() => {
        setSelectedMoreFilters({ ...selectedMoreFilters, ...props.selectedFilters })
        // eslint-disable-next-line
    }, [props.selectedFilters])
    /**
     * FILTER SEARCH HANDLER
     */
    const onFilterSearch = () => {
        props.submitHandler({ ...props.selectedFilters, ...selectedMoreFilters, page_number: PAGE_NUMBER });
        setPopupOpen(false);

    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        setSelectedMoreFilters({});
        //setSfaUserList([])
        dispatch(updateSfaUserList([]))
        props.updateSelectedFilters({ type: 'reset' });

        // props.submitHandler({activeTab: props.selectedFilters.activeTab});
        setPopupOpen(false);
    }

    const handleRoleSelection = async () => {
        props.loader(true)
        dispatch(getSfaUsersByRole({ role_id: [selectedMoreFilters['user_role']] })).then((res: any) => {
            if (res?.data) {
                setSfaUserList(res.data)
            }
        })
        props.loader(false)
    }

    const getAgencyUsers = () => {
        props.loader(true)

        getAgencyList({ isPaginationApply: false }).then((res: any) => {
            props.loader(false)
            if (res.status === STATUS_SUCCESS) {
                setSfaUserList(res?.data || [])
            }
        }).catch((err) => {
            props.loader(false)
            setSfaUserList([])
        })
    }

    const fieldMapping: any = {
        DATE_TYPE: (
            <div>
                <span className="filter-heading">{translations.Insurance?.[COUNTRY_CODE === 'id'?'APPLICATION_TYPE':'Date Type'] || translations.commonMsg?.loading}</span>

                <ReactSelect options={masterConfig['sub_status_list'] || []} value={masterConfig['sub_status_list']?.find((v: any) => +selectedMoreFilters['dateType'] === +v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder={translations.Insurance?.[COUNTRY_CODE === 'id'?'SELECT_APPLICATION_TYPE':'Select Date Type'] || translations.commonMsg?.loading} fieldKey="dateType" />
            </div>
        ),

        DATE_RANGE: (
            <div>

                <span className="filter-heading">{translations.Insurance?.['Select Date'] || translations.commonMsg?.loading}</span>
                <fieldset className='multi-datepicker'>
                    <div className="material">

                        <DatePicker
                            value={[selectedMoreFilters?.from_date, selectedMoreFilters?.to_date]}
                            onChange={(e: any) => handleChangeDateType(e, 'from_date')}
                            placeholder={translations.Insurance?.['Select Date'] || translations.commonMsg?.loading}
                            range
                            disabled={COUNTRY_CODE === 'id'?false:!selectedMoreFilters?.dateType}
                            editable={false}
                        />

                    </div>
                </fieldset>
            </div>
        ),

        INSURANCE_TYPE: (
            <div>
                <span className="filter-heading">{translations.Insurance?.['Insurance Type'] || translations.commonMsg?.loading}</span>
                <ReactSelect options={masterConfig['insurance_type'] || []} value={masterConfig['insurance_type']?.find((v: any) => +selectedMoreFilters['insurance_type_id'] === +v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder={translations.Insurance?.['Select Insurance Type'] || translations.commonMsg?.loading} fieldKey="insurance_type_id" />
            </div>
        ),
        VEHICLE_USAGE: (
            <div>
                <span className="filter-heading">{translations.Insurance?.['Vehicle Usage'] || translations.commonMsg?.loading}</span>
                <ReactSelect options={masterConfig['vehicle_usage'] || []} value={masterConfig['vehicle_usage']?.find((v: any) => +selectedMoreFilters['vehicle_usage'] === +v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder={translations.Insurance?.['Select Vehicle Usage'] || translations.commonMsg?.loading} fieldKey="vehicle_usage" />
            </div>
        ),
        VEHICLE_TYPE: (
            <div>
                <span className="filter-heading">{translations.Insurance?.['VEHICLE_TYPE'] || translations.commonMsg?.loading}</span>
                <fieldset className="multiselect-dropDown">
                    <div className="material">
                        <MultiSelect
                            options={masterConfig['vehicle_type']?.filter((v: any) => +selectedMoreFilters['vehicle_usage'] === +v.vehicle_usage) || []}
                            isSelectAll={true}
                            value={masterConfig?.['vehicle_type']?.filter((vehicle: any) => {
                                return selectedMoreFilters['vehicle_type']?.includes(vehicle.value)
                            })}
                            onChange={(e: any) => handleChangeDateType(e, 'vehicle_type')}
                            placeholder={translations.Insurance?.['SELECT_VEHICLE_TYPE'] || translations.commonMsg?.loading}
                        />
                    </div>
                </fieldset>
            </div>
        ),
        
        APPLICATION_METHOD: (
            <div className="Date-picker-sec follow-up-sec">
                <span className="filter-heading">Application Method</span>
                <ReactSelect options={masterConfig['rule_engine'] || []} value={masterConfig['rule_engine']?.find((v: any) => +selectedMoreFilters['rule_engine_id'] === +v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder="Select Application Method" fieldKey="rule_engine_id" />
            </div>
        ),

        CREATED_BY: (
            <div>
                <span className="filter-heading">{translations.Insurance?.['Created By'] || translations.commonMsg?.loading}</span>
                <fieldset className="multiselect-dropDown">
                    <div className="material">
                        <MultiSelect
                            options={COUNTRY_CODE === 'id' ? (masterConfig['sfa_roles'] || []) : (masterConfig['insurance_role'] || [])}
                            isSelectAll={true}
                            value={(COUNTRY_CODE === 'id' ? masterConfig?.['sfa_roles'] : masterConfig?.['insurance_role'])?.filter((v: any) => selectedMoreFilters['created_by_ids']?.includes(v.value))}

                            onChange={(e: any) => handleChangeDateType(e, 'created_by_ids')}
                            placeholder={translations.Insurance?.['Select Created By'] || translations.commonMsg?.loading}
                        />
                    </div>
                </fieldset>
            </div>
        ),

        BUSINESS_LINE: (
            <div>
                <span className="filter-heading">Business Line</span>
                <ReactSelect options={masterConfig?.['business_lines'] || []} value={masterConfig['business_lines']?.find((v: any) => selectedMoreFilters['business_line'] === v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder="Select Business Line" fieldKey="business_line" />
            </div>
        ),

        USER_ROLE: (
            <div>
                <span className="filter-heading">User Role</span>
                <ReactSelect options={masterConfig?.['sfa_roles'] || []} value={masterConfig['sfa_roles']?.find((v: any) => +selectedMoreFilters['user_role'] === +v.value) || null} handleChange={(e: any, fieldKey: string) => {
                    handleChangeDateType(e, fieldKey)
                    handleRoleSelection()
                }} placeholder="Select User Role" fieldKey="user_role" />
            </div>
        ),

        USER_NAME: (
            <div>
                <span className="filter-heading">{translations.Insurance?.['User Name'] || translations.commonMsg?.loading}</span>
                <fieldset className="multiselect-dropDown">
                    <div className="material">
                        <MultiSelect
                            options={sfaUserList || []}
                            isSelectAll={true}
                            value={sfaUserList.filter((user: any) => {
                                return selectedMoreFilters['username']?.includes(user.value)
                            })}
                            onChange={(e: any) => handleChangeDateType(e, 'username')}
                            placeholder={translations.Insurance?.['Select User name'] || translations.commonMsg?.loading}
                        />
                    </div>
                </fieldset>
            </div>
        ),

        EMPLOYMENT_TYPE: (
            <div>
                <span className="filter-heading">Employment Type</span>
                <ReactSelect options={masterConfig['employee_type'] || []} value={masterConfig['employee_type']?.find((v: any) => +selectedMoreFilters['employee_type'] === +v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder="Select Employment Type" fieldKey="employee_type" />
            </div>
        ),

        LEAD_SOURCE: (
            <div>
                <span className="filter-heading">Lead Source</span>
                <fieldset className="multiselect-dropDown">
                    <div className="material">
                        <MultiSelect
                            options={masterConfig['lead_source'] || []}
                            isSelectAll={true}
                            value={masterConfig['lead_source']?.filter((v: any) => selectedMoreFilters['lead_source']?.includes(v.value))}
                            onChange={(e: any) => handleChangeDateType(e, 'lead_source')}
                            placeholder="Select Lead Source"
                        />
                    </div>
                </fieldset>
            </div>
        ),

        EFFECTIVITY_DATE: (
            <div>
                <span className="filter-heading">Insurance Policy Effectivity </span>
                <fieldset className='multi-datepicker'>
                    <div className="material">
                        <DatePicker
                            value={[selectedMoreFilters?.policy_effectivity_date_from, selectedMoreFilters?.policy_effectivity_date_to]}
                            onChange={(e: any) => handleChangeDateType(e, 'policy_effectivity_date')}
                            placeholder="Select Date"
                            range
                            editable={false}
                        />
                    </div>
                </fieldset>
            </div>
        ),

        EXPIRY_DATE: (
            <div>
                <span className="filter-heading">Insurance Policy Expiry Date</span>
                <fieldset className='multi-datepicker'>
                    <div className="material">
                        <DatePicker
                            value={[selectedMoreFilters?.policy_expiry_date_from, selectedMoreFilters?.policy_expiry_date_to]}
                            onChange={(e: any) => handleChangeDateType(e, 'policy_expiry_date')}
                            placeholder="Select Date"
                            range
                            editable={false}
                        />
                    </div>
                </fieldset>
            </div>
        ),

        PAYMENT_STATUS: (
            <div>
                <span className="filter-heading">Payment Status</span>
                <ReactSelect options={masterConfig?.['paid_by_customer'] || []} value={masterConfig['paid_by_customer']?.find((v: any) => selectedMoreFilters['payment_status'] === v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder="Payment Status" fieldKey="payment_status" />
            </div>
        ),

        RENEWAL_STATUS: (
            <div>
                <span className="filter-heading">Renewal Status</span>
                <ReactSelect options={masterConfig?.['YesAndNo'] || []} value={masterConfig['YesAndNo']?.find((v: any) => selectedMoreFilters['renewal_status'] === v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder="Renewal Status" fieldKey="renewal_status" />
            </div>
        ),

        DUE_DATE: (
            <div className="more-filter-form">
                <div>

                    <span className="filter-heading">Due Date</span>
                    <fieldset className='multi-datepicker'>
                        <div className="material">

                            <DatePicker
                                value={[selectedMoreFilters?.from_due_date, selectedMoreFilters?.to_due_date]}
                                onChange={(e: any) => handleChangeDateType(e, 'from_due_date')}
                                placeholder="Select Due Date"
                                range
                                editable={false}
                            />

                        </div>
                    </fieldset>
                </div>
            </div>
        ),

        SOURCE_TYPE: (
            <div className="more-filter-form">
                <div>
                    <span className="filter-heading">Source Type</span>
                    <fieldset className="multiselect-dropDown">
                        <div className="material">
                            <MultiSelect
                                options={leadSourceOptions || []}
                                isSelectAll={true}
                                value={leadSourceOptions?.filter((v: any) => selectedMoreFilters['lead_source_type']?.includes(COUNTRY_CODE === 'id' ? v.lead_type :v.value))}
                                onChange={(e: any) => handleChangeDateType(e, 'lead_source_type')}
                                placeholder="Source Type"
                            />
                        </div>
                    </fieldset>
                </div>
            </div>
        ),
        PRIORITY: (
            <div>
                <span className="filter-heading">{translations.Insurance?.['PRIORITY'] || translations.commonMsg?.loading}</span>
                <ReactSelect 
                   options={masterConfig['priority'] || []} value={masterConfig['priority']?.find((v: any) => +selectedMoreFilters['priority'] === +v.value) || null} 
                   handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} 
                   placeholder={translations.Insurance?.['SELECT_PRIORITY'] || translations.commonMsg?.loading} 
                   fieldKey="priority" />
            </div>
        ),

        MULTI_TENURE: (
            <div>
                <span className="filter-heading">{translations.Insurance?.['Multi Tenure'] || translations.commonMsg?.loading}</span>
                <ReactSelect options={masterConfig['insurance_type'] || []} value={masterConfig['insurance_type']?.find((v: any) => +selectedMoreFilters['tenure_insurance_type'] === +v.value) || null} handleChange={(e: any, fieldKey: string) => handleChangeDateType(e, fieldKey)} placeholder={translations.Insurance?.['Select Multi Tenure'] || translations.commonMsg?.loading} fieldKey="tenure_insurance_type" />
            </div>
        )
    }

    let visibleFields: any = Object.keys(fieldMapping)?.filter((field: any) => FEATURE_LISTING['INSURANCE_LIST']['MORE_FILTERS'][field])

    return (
        <React.Fragment>
            <div className="filter-option">
                <Dropdown show={isPopupOpen} onToggle={(isOpen: any) => setPopupOpen(isOpen)}>
                    <div className="text-btn d-flex">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            <span className="more-filter-txt">{translations.Insurance?.['More Filters'] || translations.commonMsg?.loading}</span>
                            <span className="leass-filter-txt">{translations.Insurance?.['Less Filters'] || translations.commonMsg?.loading}</span>
                        </Dropdown.Toggle>
                        <div className="btn-submit-reset top-btn-none">
                            <button className="btn-primary" onClick={onFilterSearch}>{translations.commonMsg?.['search'] || translations.commonMsg?.loading}</button>
                            <button className="btn-reset" onClick={onFilterReset}>{translations.commonMsg?.['reset'] || translations.commonMsg?.loading}</button>
                        </div>
                    </div>
                    <Dropdown.Menu>
                        <div className="more-filter-option">
                            <h3>{translations.Insurance?.['More Filters'] || translations.commonMsg?.loading}</h3>
                            <div className="filter-form">
                                {
                                    times(Math.ceil(visibleFields?.length / 2), (idx: number) => {
                                        const chunk = visibleFields.slice(idx * 2, idx * 2 + 2);

                                        return (
                                            <div className="more-filter-form" key={`chunk-${idx}`}>
                                                {chunk.map((field: any) => (
                                                    <React.Fragment key={field}>
                                                        {fieldMapping[field]}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        );
                                    })
                                }

                                <div className="btn-submit-reset more-filter-btn">
                                    <button className="btn-primary" onClick={onFilterSearch}>{translations.commonMsg?.['search'] || translations.commonMsg?.loading}</button>
                                    <button className="btn-reset" onClick={onFilterReset}>{translations.commonMsg?.['reset'] || translations.commonMsg?.loading}</button>
                                </div>
                            </div>
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </React.Fragment>
    );
};

export default MoreFilterOption;
